export const RATING_FORM = {
    FIELD_RATING: 'rating',
    FIELD_PUBLISH_NAME: 'publishName',
    FIELD_SUMMARY: 'summary',
    FIELD_DESCRIPTION: 'description',
    FIELD_PURCHASE_ON: 'purchaseOn',
};

export const CONTACT_FORM = {
    FIELD_CUSTOMER_NUMBER: 'customerNumber',
    FIELD_FIRSTNAME: 'firstName',
    FIELD_LASTNAME: 'lastName',
    FIELD_EMAIL_ADDRESS: 'email',
};

export const FORM_FIELD_NAMES: string[] = [
    RATING_FORM.FIELD_RATING,
    RATING_FORM.FIELD_PUBLISH_NAME,
    RATING_FORM.FIELD_SUMMARY,
    RATING_FORM.FIELD_DESCRIPTION,
    RATING_FORM.FIELD_PURCHASE_ON,
    CONTACT_FORM.FIELD_CUSTOMER_NUMBER,
    CONTACT_FORM.FIELD_FIRSTNAME,
    CONTACT_FORM.FIELD_LASTNAME,
    CONTACT_FORM.FIELD_EMAIL_ADDRESS,
];

export const FORM_NAME_WRITING_PRODUCT_REVIEW: string = 'writingProductReviewForm';

export const NAME_WRITING_PRODUCT_REVIEW_DIALOG: string = 'writing-product-review-dialog';

export const NAME_PRODUCT_REVIEW_WARNING_CLOSE_DIALOG: string = 'product-review-warning-close-dialog';
